/**
 * نسخه بدون سرور Node: همه‌چیز با PHP کار می‌کند (polling).
 * این فایل عمداً خالی (no-op) است تا نیازی به نصب بسته‌های اضافه نباشد.
 */
const noop: any = { connected: false, id: undefined, on() { return noop; }, off() { return noop; }, emit() { return noop; }, disconnect() { /* */ } };
export function connectSocket(): any { return noop; }
export const getSocket = (): any => null;
export function disconnectSocket() { /* */ }
